// EXTERNAL
import { useState } from "react";
// COMPONENTS
import * as ComponentLibrary from "@picnicmedia/masanatemples123";
// ASSETS
import placeholderPostBackground from "../../assets/placeholder-background-post.jpg";
// LIBS
import { Google_Analytics_Event } from "../../libs/google-analytics";
import { analytics_record } from "../../libs/amplify";
// HELPERS
import { handleDragStart, handleDragOver, handleDragEnd, updateFrameData } from "../../helpers/draggable_frames";
import add_asset from "../../helpers/add_asset";
import edit_asset from "../../helpers/edit_asset";
// CONTEXT
import { useCreativeState, useCreativeDispatch } from "../../contexts/creative.context";
import { useNotificationDispatch } from "../../contexts/notification.context";
import { useUserState } from "../../contexts/user.context";
import { useMediaLoadingDispatch } from "../../contexts/mediaLoading.context";
import config from "../../configs/config";

// TYPES
type TypeStudioConfig = {
  [key: string]: any;
};

export default function CarouselFormat() {
  const user = useUserState();
  const creative = useCreativeState();
  const creativeDispatch = useCreativeDispatch();
  const notificationDispatch = useNotificationDispatch();
  const mediaLoadingDispatch = useMediaLoadingDispatch();
  const activeSlide = creative.metadata.slides[creative.slideIndex];
  const [backgroundModalState, setBackgroundModalState] = useState(false);
  let studioConfig: TypeStudioConfig = require("../../configs/studio.json");
  const frameRatios = studioConfig.formats.carousel.media.frameRatios;
  const matchedFrameRatio = frameRatios.findIndex((frameRatio: FrameRatio) => frameRatio.name === creative.metadata.aspectRatio);
  const [aspectRatioWidth, aspectRatioHeight] = studioConfig.formats[creative.metadata.format].media.frameRatios[matchedFrameRatio].ratio.split(":").map(Number);

  return (
    <>
      <div className="flex flex-column justify-center">
        <ComponentLibrary.PCSpacer type={"margin"} position={"top"} size={3} />
        {/* ********************** */}
        {/* FRAMES */}
        {/* ********************** */}
        {creative.metadata.slides[0].id !== "" ? (
          <>
            {creative.metadata.slides
              .sort((a: any, b: any) => a.slideNumber - b.slideNumber)
              .slice(0, studioConfig.formats.carousel.maxSlides)
              .map((slide: any) => (
                <div key={slide.id}>
                  <ComponentLibrary.PCContainerDraggable isDraggable={!slide.control.isToggleContainerOpen} handleDragStart={(e: any) => handleDragStart(e, creative, creativeDispatch)} handleDragOver={(e: any) => handleDragOver(e, creative, creativeDispatch)} handleDragEnd={(e: any) => handleDragEnd(e, creative, creativeDispatch)} containerId={slide.id} dataPosition={slide.slideNumber}>
                    <ComponentLibrary.PCContainerToggle
                      isOpen={slide.control.isToggleContainerOpen}
                      borderOption={slide.control.isToggleContainerOpen ? "border-radius-top" : null}
                      thumbnail={slide.media.plainImage || slide.media.thumbnail || placeholderPostBackground}
                      thumbnailHeight={"48px"}
                      thumbnailWidth={"48px"}
                      frameNumber={slide.slideNumber}
                      handleOpen={() => updateFrameData(slide, creativeDispatch, creative)}
                      assetMimeType={"image"}
                      handleDelete={
                        creative.metadata.slides.length > 1
                          ? () => {
                              creativeDispatch({
                                type: "UPDATE_CREATIVE_SLIDEINDEX",
                                payload: { slideIndex: 0 },
                              });
                              creativeDispatch({
                                type: "UPDATE_CREATIVE_ELEMENTINDEX",
                                payload: { elementIndex: 0 },
                              });
                              creativeDispatch({
                                type: "REMOVE_SLIDE",
                                payload: {
                                  id: slide.id,
                                },
                              });
                              creativeDispatch({
                                type: "UPDATE_CREATIVE_METADATA_SLIDE_SLIDENUMBERS",
                                payload: {
                                  newSlideOrder: creative.metadata.slides.filter((frame: any) => frame.slideNumber !== slide.slideNumber).map((filteredFrame: any) => filteredFrame.id),
                                },
                              });
                            }
                          : () => {
                              creativeDispatch({
                                type: "REMOVE_SLIDE",
                                payload: {
                                  id: slide.id,
                                },
                              });
                              creativeDispatch({
                                type: "ADD_NEW_SLIDE",
                                payload: { slideNumber: 1 },
                              });
                            }
                      }>
                      <ComponentLibrary.PCSpacer type={"margin"} position={"top"} size={1} />
                      <ComponentLibrary.PCContainerMain borderRadiusDirection="bottom">
                        <ComponentLibrary.PCSpacer type={"margin"} position={"around"} size={4}>
                          <ComponentLibrary.PCSubHeader text={"Frame Settings"} />
                          <ComponentLibrary.PCSpacer type={"margin"} position={"top"} size={5} />
                          <div className="flex">
                            <ComponentLibrary.PCPreviewImage height={"128px"} width={"128px"} backgroundImage={slide.media.plainImage || slide.media.thumbnail || placeholderPostBackground} />
                            <ComponentLibrary.PCSpacer type={"margin"} position={"left"} size={5} />
                            <div className="flex flex-column justify-center">
                              <div className="self-start">
                                <ComponentLibrary.PCCaption text={slide.media.fileName.length > 30 ? `${slide.media.fileName.substring(0, 29)}...` : slide.media.fileName} fontWeight={"4"} />
                              </div>
                              <ComponentLibrary.PCSpacer type={"margin"} position={"top"} size={3} />
                              <div className="flex">
                                <ComponentLibrary.PCActionButton text={slide.media.mimeType === "video/mp4" ? "Crop video" : "Crop image"} textColor={"platform-color-typography-titles-3"} color={"platform-background-platform-background-4"} clickHandler={() => setBackgroundModalState(!backgroundModalState)} />
                                <ComponentLibrary.PCDialogueBox open={backgroundModalState} width={"width-13"} height={"height-13"} onClose={() => setBackgroundModalState(!backgroundModalState)}>
                                  <>
                                    <ComponentLibrary.PCCropper
                                      /**
                                       * HTL (20-06-23)
                                       * Setting the preview media to an image, if the format is one format or the other.
                                       */
                                      media={(slide.media.mimeType.includes("video") ? slide.media.plainImage : slide.media.bodyOriginal) || placeholderPostBackground}
                                      mimeType={slide.media.mimeType.includes("video") ? "image/jpeg" : slide.media.mimeType}
                                      crop={slide.media.crop}
                                      zoom={slide.media.zoom}
                                      aspect={aspectRatioWidth / aspectRatioHeight}
                                      onCropChange={(crop: any) => {
                                        creativeDispatch({
                                          type: "UPDATE_CREATIVE_METADATA_SLIDE_MEDIA_CROP_X",
                                          payload: {
                                            id: slide.slideNumber,
                                            x: crop.x,
                                          },
                                        });
                                        creativeDispatch({
                                          type: "UPDATE_CREATIVE_METADATA_SLIDE_MEDIA_CROP_Y",
                                          payload: {
                                            id: slide.slideNumber,
                                            y: crop.y,
                                          },
                                        });
                                      }}
                                      onZoomChange={(zoom: any) => {
                                        creativeDispatch({
                                          type: "UPDATE_CREATIVE_METADATA_SLIDE_MEDIA_ZOOM",
                                          payload: {
                                            id: slide.slideNumber,
                                            zoom,
                                          },
                                        });
                                      }}
                                      onCropComplete={(croppedArea: any, croppedAreaPixels: any) => {
                                        creativeDispatch({
                                          type: "UPDATE_CREATIVE_METADATA_SLIDE_MEDIA_CROPPEDAREAPIXELS_WIDTH",
                                          payload: {
                                            id: slide.slideNumber,
                                            width: croppedAreaPixels.width,
                                          },
                                        });
                                        creativeDispatch({
                                          type: "UPDATE_CREATIVE_METADATA_SLIDE_MEDIA_CROPPEDAREAPIXELS_HEIGHT",
                                          payload: {
                                            id: slide.slideNumber,
                                            height: croppedAreaPixels.height,
                                          },
                                        });
                                        creativeDispatch({
                                          type: "UPDATE_CREATIVE_METADATA_SLIDE_MEDIA_CROPPEDAREAPIXELS_X",
                                          payload: {
                                            id: slide.slideNumber,
                                            x: croppedAreaPixels.x,
                                          },
                                        });
                                        creativeDispatch({
                                          type: "UPDATE_CREATIVE_METADATA_SLIDE_MEDIA_CROPPEDAREAPIXELS_Y",
                                          payload: {
                                            id: slide.slideNumber,
                                            y: croppedAreaPixels.y,
                                          },
                                        });
                                      }}
                                      buttonClickHandler={async () => {
                                        /**
                                         * HTL (11-08-23)
                                         * Adding Google sheet click event if creative.socialURL exists, AKA user has used social fetch.
                                         */
                                        if (creative.metadata.socialUrl) {
                                          analytics_record({
                                            name: "media_edit",
                                            attributes: {
                                              eventType: "click",
                                              userId: `${user.id}`,
                                              userEmail: `${user.email}`,
                                              teamId: `${user.teamId}`,
                                              teamName: `${user.teamName}`,
                                            },
                                          });
                                        }
                                        Google_Analytics_Event({ name: "media_edit", category: "ad_creative", action: "crop", label: creative.creativeId });
                                        mediaLoadingDispatch({ type: "UPDATE_LOADING_STATE", payload: { status: true, type: "crop", message: "Cropping asset", progress: Math.floor(Math.random() * (10 - 3 + 1) + 3) } });
                                        try {
                                          setBackgroundModalState(false);
                                          await edit_asset({
                                            method: "crop",
                                            slideNumber: slide.slideNumber,
                                            teamId: user.teamId,
                                            creativeId: creative.creativeId,
                                            fileName: slide.media.fileName,
                                            fileId: slide.media.id,
                                            mimeType: slide.media.mimeType,
                                            duration: slide.media.originalVideoDuration,
                                            inputWidth: slide.media.croppedAreaPixels.width,
                                            inputHeight: slide.media.croppedAreaPixels.height,
                                            outputWidth: studioConfig.formats[creative.metadata.format].media.frameRatios[matchedFrameRatio].width,
                                            outputHeight: studioConfig.formats[creative.metadata.format].media.frameRatios[matchedFrameRatio].height,
                                            cropX: slide.media.croppedAreaPixels.x,
                                            cropY: slide.media.croppedAreaPixels.y,
                                            videoSplitFrame: slide.media.videoSplitFrame,
                                            notificationDispatch,
                                            creativeDispatch,
                                            mediaLoadingDispatch,
                                          });
                                          mediaLoadingDispatch({ type: "UPDATE_LOADING_STATE", payload: { status: false, type: "", message: "", progress: 0 } });
                                        } catch (error) {
                                          setBackgroundModalState(false);
                                          mediaLoadingDispatch({ type: "UPDATE_LOADING_STATE", payload: { status: false, type: "", message: "", progress: 0 } });
                                          return notificationDispatch({
                                            type: "ADD",
                                            payload: {
                                              header: "Error",
                                              message: "Something went wrong.",
                                              type: "error",
                                              autoDismiss: false,
                                            },
                                          });
                                        }
                                      }}
                                    />
                                  </>
                                </ComponentLibrary.PCDialogueBox>
                                <ComponentLibrary.PCSpacer type={"margin"} position={"left"} size={3} />
                                <ComponentLibrary.PCDivider vertical={true} />
                                <ComponentLibrary.PCSpacer type={"margin"} position={"left"} size={3} />
                                <div className="upload-button-wrapper dim relative overflow-hidden dib-ns">
                                  <input
                                    type="file"
                                    className="o-0 absolute top-0 left-0 h-100"
                                    style={{
                                      cursor: "pointer",
                                    }}
                                    name="brand_logo_upload_carousel"
                                    id="brand_logo_upload_carousel"
                                    onChange={async (e: any) => {
                                      mediaLoadingDispatch({ type: "UPDATE_LOADING_STATE", payload: { status: true, type: "upload", message: "Uploading asset", progress: Math.floor(Math.random() * (10 - 3 + 1) + 3) } });
                                      try {
                                        await add_asset({
                                          file: e.target.files[0],
                                          slideNumber: slide.slideNumber,
                                          formatType: creative.metadata.format,
                                          aspectRatio: creative.metadata.aspectRatio,
                                          teamId: user.teamId,
                                          creativeId: creative.creativeId,
                                          creativeDispatch,
                                          mimeType: e.target.files[0].type,
                                          name: e.target.files[0].name,
                                          mediaLoadingDispatch,
                                        });
                                        mediaLoadingDispatch({ type: "UPDATE_LOADING_STATE", payload: { status: false, type: "", message: "", progress: "0" } });
                                      } catch (error) {
                                        mediaLoadingDispatch({ type: "UPDATE_LOADING_STATE", payload: { status: false, type: "", message: "", progress: "0" } });
                                        return notificationDispatch({
                                          type: "ADD",
                                          payload: {
                                            header: error.message,
                                            message: error.cause,
                                            type: "error",
                                            autoDismiss: false,
                                          },
                                        });
                                      }
                                    }}
                                    onClick={(e: any) => {
                                      e.target.value = null;
                                    }}
                                  />
                                  <ComponentLibrary.PCActionButton text={"Replace"} textColor={"platform-color-typography-titles-3"} color={"platform-background-platform-background-4"} />
                                </div>
                              </div>
                            </div>
                          </div>
                          <ComponentLibrary.PCSpacer type={"margin"} position={"top"} size={5} />
                          {/** JA (21-08-23) Carousel MPU does not support frame text or frame clickouts */}
                          {/** https://www.notion.so/picnicmedia/UI-component-for-selecting-new-IAB-sizes-9fbaf5cfd14f49aa8fc9e31999a6f122?pvs=4#7c00e03d769a47fc933ba5d6446726fc */}
                          {creative.metadata.aspectRatio !== "mpu" && (
                            <>
                              <ComponentLibrary.PCDivider />
                              <ComponentLibrary.PCSpacer type={"margin"} position={"top"} size={5} />
                              <div className="w-50">
                                <ComponentLibrary.PCInput
                                  value={decodeURI(slide.content)}
                                  label={"Frame text"}
                                  placeholder={`Frame ${slide.slideNumber} of carousel`}
                                  type={"text"}
                                  handleChange={(e: any) => {
                                    const { value } = e.target;
                                    creativeDispatch({
                                      type: "UPDATE_CREATIVE_METADATA_SLIDE_CONTENT",
                                      payload: {
                                        id: slide.slideNumber,
                                        content: value,
                                      },
                                    });
                                  }}
                                  subHeader={"1 - 45 characters"}
                                  maxChar={45}
                                  characterCounter={true}
                                  minNum={1}
                                />
                              </div>
                              <ComponentLibrary.PCSpacer type={"margin"} position={"top"} size={3} />
                              <div className="w-50">
                                <ComponentLibrary.PCInput
                                  value={slide.button.clickout}
                                  label={`${!config.managedServiceTeamIds.includes(user.teamId) ? "Preview link click out URL" : `Frame ${slide.slideNumber} Click out URL`}`}
                                  placeholder={"Paste URL"}
                                  tooltipMessage={"(Optional) Host different click-outs per card to drive users through to individual landing pages"}
                                  type={"text"}
                                  handleChange={(e: any) => {
                                    const { value } = e.target;
                                    creativeDispatch({
                                      type: "UPDATE_CREATIVE_METADATA_SLIDE_CLICKOUT",
                                      payload: {
                                        id: slide.slideNumber,
                                        clickout: value,
                                      },
                                    });
                                  }}
                                />
                              </div>
                            </>
                          )}
                        </ComponentLibrary.PCSpacer>
                      </ComponentLibrary.PCContainerMain>
                    </ComponentLibrary.PCContainerToggle>
                  </ComponentLibrary.PCContainerDraggable>
                  <ComponentLibrary.PCSpacer type={"margin"} position={"top"} size={2} />
                </div>
              ))}
            <ComponentLibrary.PCNewFrame
              thumbnailHeight={"48px"}
              thumbnailWidth={"48px"}
              disabled={creative.metadata.slides.length >= studioConfig.formats.carousel.maxSlides}
              handleClick={() => {
                if (creative.metadata.slides.length < studioConfig.formats.carousel.maxSlides) {
                  creativeDispatch({
                    type: "UPDATE_CREATIVE_METADATA_SLIDE_CONTROL_ISOPEN",
                    payload: {
                      id: activeSlide.id,
                      isToggleContainerOpen: false,
                    },
                  });
                  creativeDispatch({
                    type: "ADD_NEW_SLIDE",
                    payload: { slideNumber: creative.metadata.slides.length + 1 },
                  });
                  creativeDispatch({
                    type: "UPDATE_CREATIVE_SLIDEINDEX",
                    payload: { slideIndex: creative.metadata.slides.length },
                  });
                }
              }}
            />
          </>
        ) : null}
      </div>
    </>
  );
}
